<template>
    <b-container>
        <div class="login-form">
            <img src="https://drop.rautec.de/static/company_logo.png" class="login-form-logo">

            <b-form @submit.prevent="login" v-if="!forgotPassword">
                <b-form-group label="Nutzername:" label-for="inputUsername">
                    <b-form-input
                        id="inputUsername"
                        ref="usernameRef"
                        type="text"
                        v-model="username"
                        required
                        placeholder="Nutzername" />
                </b-form-group>

                <b-form-group label="Passwort:" label-for="inputPassword">
                    <b-form-input
                        id="inputPassword"
                        type="password"
                        v-model="password"
                        required
                        placeholder="Passwort" />
                </b-form-group>

                <b-button type="submit" variant="primary">{{ 'login.login' | translate }}</b-button>
                <b-button class="float-right" variant="secondary" @click="forgotPasswordClicked">{{ 'login.forgot' | translate }}</b-button>
            </b-form>
            <b-form v-else @submit.prevent="resetPassword">
                <b-form-group label="Nutzername:" label-for="inputUsernameReset">
                    <b-form-input
                        id="inputUsernameReset"
                        ref="usernameRef"
                        type="text"
                        v-model="forgotUsername"
                        required
                        placeholder="Nutzername" />
                </b-form-group>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <img id="captcha" v-bind:src="forgotCaptchaUrl" alt="Captcha"/>
                            <span class="reload-icon" aria-hidden="true" @click="refreshCaptcha"></span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Captcha:" label-for="inputCaptcha">
                            <b-form-input
                                id="inputCaptcha"
                                type="text"
                                v-model="forgotCaptcha"
                                required
                                placeholder="" />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-button variant="secondary" @click="forgotPassword = false">{{ 'login.forgot.back' | translate }}</b-button>
                <b-button type="submit" variant="primary" class="float-right">{{ 'login.forgot.reset' | translate }}</b-button>
            </b-form>
            <b-alert show variant="danger" dismissible @dismissed="status = ''" v-if="status.length > 0">
                {{ status }}
            </b-alert>
        </div>
    </b-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'Login',
        data() {
            return {
                username: '',
                password: '',
                forgotUsername: '',
                forgotCaptcha: '',
                forgotCaptchaUrl: 'https://drop.rautec.de/api/auth/captcha?t=' + +new Date(),
                forgotPassword: false,
                status: '',
                showRequestError: false,
                showInvalidUsernameOrPassword: false,
                showAccountBlocked: false,
                showForgotPasswordNeedUsername: false,
                showPasswordResetSuccessful: false,
                showPasswordResetError: false,
                showInvalidCaptcha: false
            }
        },
        methods: {
            refreshCaptcha: function () {
                this.forgotCaptchaUrl = this.forgotCaptchaUrl.split('=')[0] + '=' + +new Date();
            },
            forgotPasswordClicked: function () {
                this.forgotPassword = true;
            },
            resetPassword: function () {
                if (!this.forgotUsername) {
                    this.status = this.$globalStore.translate('login.forgot.username.need');
                    return;
                }

                this.status = '';

                let formData = new FormData();
                formData.append('username', this.forgotUsername);
                formData.append('captcha', this.forgotCaptcha);

                this.forgotUsername = '';
                this.forgotCaptcha = '';

                axios.post('https://drop.rautec.de/api/auth/reset', formData).then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('login.forgot.successful', true);
                    } else if (response.data.invalidCaptcha) {
                        this.status = this.$globalStore.translate('login.forgot.captcha.invalid');
                    } else {
                        this.status = this.$globalStore.translate('login.forgot.error');
                    }
                }).catch(reason => {
                    this.status = this.$globalStore.translate('login.forgot.error');
                });
            },
            login: function () {
                if (this.username === '' || this.password === '') {
                    return;
                }

                this.status = '';

                let formData = new FormData();
                formData.append('username', this.username);
                formData.append('password', this.password);

                axios.post('https://drop.rautec.de/api/auth/login', formData).then(response => {
                    if (response.data.success) {
                        this.$globalStore.authed = true;
                        this.$globalStore.group = response.data.group;
                        this.$globalStore.lastName = response.data.lastName;

                        this.$globalStore.loadTranslation(response.data.language);

                        this.$router.push('/home');
                    } else {
                        this.status = this.$globalStore.translate('login.invalid.credentials');
                    }

                    this.username = '';
                    this.password = '';
                }).catch(reason => {
                    this.username = '';
                    this.password = '';

                    this.$globalStore.authed = false;
                    this.$globalStore.group = 0;
                    this.$globalStore.firstName = '';
                    this.$globalStore.lastName = '';

                    this.status = this.$globalStore.translate('login.request.error');
                });
            }
        },
        mounted() {
            this.$refs.usernameRef.$el.focus();
        }
    }
</script>

<style scoped>
    .login-form {
        width: 340px;
        margin: 50px auto;
    }

    .login-form form {
        margin-bottom: 15px;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
        padding: 30px;
    }

    .login-form-logo {
        margin-top: -50px;
        margin-bottom: 10px;
        width: 250px;
    }

    .reload-icon {
        background: url('/static/reload.png') no-repeat top left;
        width: 16px;
        height: 16px;
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue